import { render, staticRenderFns } from "./PlacementMultiplier.vue?vue&type=template&id=10afaef3&scoped=true&"
import script from "./PlacementMultiplier.vue?vue&type=script&lang=js&"
export * from "./PlacementMultiplier.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./PlacementMultiplier.vue?vue&type=style&index=0&id=10afaef3&scoped=true&lang=scss&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "10afaef3",
  null
  ,true
)

export default component.exports